<script>
import { FilterMatchMode } from 'primevue/api';
import Utils from '../../../common/Utils';
import CommonConstants from '../../../common/Constants';
import Service from '@/services/planning';
import ResponsiveButton from '../../../components/generic/ResponsiveButton.vue'
//import { FilterMatchMode, FilterOperator } from 'primevue/api'
import GenericCustomMasterDataAutocompleteV2 from '@/components/generic/GenericCustomMasterDataAutocompleteV2.vue';

export default {
    components: 
        {
            GenericCustomMasterDataAutocompleteV2,
            ResponsiveButton
        },
    props: [],
    data() {
        return {                            
            priceFormula: [],
            priceFormulaDetails: [],
            editPriceFormula: [],
            editPriceFormulaDetails: [],
            selectedFormula: null,
            selectedPriceFormula: {},
            showPriceFormulaDialog: false,
            showPriceFormulaDetailsDialog: false,
            savePriceFormulaHeaderDisabled: false,
            priceFormulaHeader: {},
            priceFormulaDetailsItem: {},
            priceFormulaFilters: {
                description: { value: null, matchMode: FilterMatchMode.CONTAINS },
                currencyCode: { value: null, matchMode: FilterMatchMode.CONTAINS },
                quantityUnitOfMeasureCode: { value: null, matchMode: FilterMatchMode.CONTAINS },
                registryCalculationType: { value: null, matchMode: FilterMatchMode.CONTAINS },
                shortDescription: { value: null, matchMode: FilterMatchMode.CONTAINS }
            },
        }
    },
    created() {
        this.$store.dispatch('security/setNavbarTitle', 'trueUp.priceFormula');
    },
    mounted() {
        this.loadPriceFormula();
    },
    computed: {
        constants() {
            return CommonConstants; 
        },
        utils() {
            return Utils;
        },
        uiPermissions() {
            return this.$store.getters['security/uiPermissions'];
        }
    },
    methods: {
        loadPriceFormula(){   
            let filters = [];
            let params = {
                filter: JSON.stringify(filters),
            }
           
            this.$store.dispatch("generic/setLoading", true);
            Service.getPriceFormula(params, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.priceFormula = response.data;
                }
            })
        },
        onPriceFormulaRowEditSave(data){
            this.$store.dispatch("generic/setLoading", true);
            Service.updatePriceFormula(data.newData, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                    this.loadPriceFormula();
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        onPriceFormulaDetailRowEditSave(data){
            this.$store.dispatch("generic/setLoading", true);
            Service.updatePriceFormulaDetails(data.newData, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                    this.loadDetails(this.selectedFormula);
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        onHeaderSelect(e){
            this.selectedFormula = e.data.id;
            this.loadDetails(e.data.id);
        },
        loadDetails(headerId){
            let filters = [
                {
                operator: 'eq',
                value: headerId,
                property: 'IdPlanningPriceFormula'
                }
            ];
            let params = {
                filter: JSON.stringify(filters),
            }

            Service.getPriceFormulaDetails(params, response => {
                if(response.success){
                this.priceFormulaDetails = response.data;
                }else{
                this.priceFormulaDetails = [];
                }
            })
        },
        submitPriceFormulaHeader(){
            Service.addPriceFormula(this.priceFormulaHeader, 
            response => {
              if(response.success){
                this.showPriceFormulaDialog = false;
                this.loadPriceFormula();
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});
              }else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
              }
            })
        },
        openDialogAddPriceFormulaDetails(){
            console.log(this.selectedPriceFormula);
            this.priceFormulaDetailsItem = {
                idPlanningPriceFormula: this.selectedPriceFormula.id
            };
            this.showPriceFormulaDetailsDialog = true;
        },
        submitPriceFormulaDetails(){
            Service.addPriceFormulaDetails(this.priceFormulaDetailsItem, 
            response => {
              if(response.success){
                this.showPriceFormulaDetailsDialog = false;
                this.loadDetails(this.selectedPriceFormula.id);
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});
              }else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
              }
            })
        },
        deleteDetails(id){
            this.$confirm.require({
                message: this.$t('messages.delete_message_question'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {                  
                    Service.deletePriceFormulaDetails(id, ({success, message}) => {
                        if(success){
                            this.loadDetails(this.selectedPriceFormula.id);
                            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000});
                        } else{
                            this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                        }
                    })
                },
                reject: () => {
                    this.$confirm.close();
                }
            });
        }
    },
    beforeRouteLeave(to, from, next) {
      if(this.editPriceFormula.length > 0 || this.editPriceFormulaDetails.length > 0){
        this.$confirm.require({
            message: this.$t('Settle.exitMessage'),
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: this.$t('yes'),
            rejectLabel: this.$t('no'),
            accept: () => {
                this.nextRoute = next;
                window.removeEventListener('beforeunload', this.handleBeforeUnload);
                this.nextRoute();
            },
            reject: () => {
                this.$confirm.close();
            }
        });
      }else{
        this.nextRoute = next;
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
        this.nextRoute();
      }
    }
}
</script>

<template>
    <main>
        <div class="grid">
            <div class="col-12">             
                <div class="grid">
                    <Card class="col-12" >
                        <template #content>
                            <Dialog v-model:visible="showPriceFormulaDialog" modal class="p-fluid">
                                <div class="field">
                                    <label for="description">{{ $t('trueUp.description') }}</label>
                                    <InputText class="w-full p-inputtext-sm mt-1 " id="priceFormulaDescription" type="text" v-model="priceFormulaHeader.description"/>
                                </div>
                                <div class="field">
                                    <label for="shortDescription">{{ $t('trueUp.shortDescription') }}</label>
                                    <InputText class="w-full p-inputtext-sm mt-1 " id="priceFormulaShortDescription" type="text" v-model="priceFormulaHeader.shortDescription"/>
                                </div>

                                <div class="field">
                                    <label for="registryCalculationType">{{ $t('trueUp.registryCalculationType') }}</label>
                                    <GenericCustomMasterDataAutocompleteV2
                                    class="p-inputtext-sm w-full"
                                    v-model="priceFormulaHeader.idRegistryCalculationType"
                                    api="masterdata/registry-calculation-type-combo" 
                                    name="masterdata-calculation-type-combo"/> 
                                </div>

                                <div class="field">
                                    <label for="quantityUnitOfMeasureCode">{{ $t('trueUp.quantityUnitOfMeasureCode') }}</label>
                                    <GenericCustomMasterDataAutocompleteV2
                                    class="p-inputtext-sm w-full"
                                    v-model="priceFormulaHeader.quantityUnitOfMeasureCode"
                                    api="masterdata/unit-of-measure-combo?getOnlyValid=true&scope=PriceFormula" 
                                    name="masterdata-unit-of-measure-combo"/>
                                </div>

                                <div class="field">
                                    <label for="currencyCode">{{ $t('trueUp.currencyCode') }}</label>
                                    <GenericCustomMasterDataAutocompleteV2
                                    class="p-inputtext-sm w-full"
                                    v-model="priceFormulaHeader.currencyCode"
                                    api="masterdata/currency-combo?getOnlyValid=true" 
                                    name="masterdata-currency-combo"/>
                                </div>

                                <div class="field">
                                    <label for="formula">{{ $t('trueUp.formula') }}</label>
                                    <InputText class="w-full p-inputtext-sm mt-1 " id="formula" type="text" v-model="priceFormulaHeader.formula"/>
                                </div>

                                <template #footer>
                                    <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" class="p-button-text" @click="showPriceFormulaDialog = false"/>
                                    <ResponsiveButton :label="$t('btn.save')" icon="pi pi-check" class="p-button-text" @click="submitPriceFormulaHeader" :disabled="savePriceFormulaHeaderDisabled"/>
                                </template>
                            </Dialog>
                            <div class="grid">
                                <div class="col-12" style="height: calc(56.5vh)" >
                                    <DataTable showGridlines v-model:filters="priceFormulaFilters" filterDisplay="row" :value="priceFormula" scrollable :responsiveLayout="'stack'" scrollHeight="flex" sortMode="single"
                                        :sortOrder="1" editMode="row" size="small" v-model:editing-rows="editPriceFormula" @row-edit-save="onPriceFormulaRowEditSave" 
                                        dataKey="id" v-model:selection="selectedPriceFormula" selectionMode="single" @rowSelect="onHeaderSelect" 
                                        paginator :rows="10" :rowsPerPageOptions="[10, 20, 50]" class="p-datatable-sm" stripedRows >

                                    <template #header>
                                        <Toolbar>
                                            <template #start>
                                                <div class="custom-card-title">{{$t('trueUp.priceFormulaHeader')}}</div>
                                            </template>

                                            <template #end>
                                            <ResponsiveButton :label="$t('btn.add')" icon="pi pi-plus" class="p-button-outlined p-button-sm" @click="showPriceFormulaDialog = true" v-if="!uiPermissions('priceFormulaAddButton').isHidden" />
                                            </template>
                                        </Toolbar>
                                    </template>
                                        <!--<Column class="button-column" :exportable="false" :reorderableColumn="false">
                                            <template #body="slotProps">
                                                <Button v-tooltip="$t('trueUp.priceFormulaDelete')" icon="fa-solid fa-trash" class="p-button-sm p-button-rounded p-button-outlined mr-1 mb-1" 
                                                size="small" @click="openDownloadDialog(slotProps.data)" />
                                            </template>
                                        </Column> -->

                                        <Column v-tooltip="$t('trueUp.priceFormulaEdit')" :rowEditor="true" style="width: 150px;" v-if="!uiPermissions('priceFormulaEditButton').isHidden" />
                                                            
                                        <Column field="description" :header="$t('trueUp.description')" >
                                            <template #editor="{ data, field }">
                                                <InputText class="w-full" autoResize v-model="data[field]" />
                                            </template>
                                            <template #filter="{ filterModel, filterCallback }">
                                                <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter"  />
                                            </template>
                                        </Column>

                                        <Column field="shortDescription" :header="$t('trueUp.shortDescription')" >
                                            <template #editor="{ data, field }">
                                                <InputText class="w-full" autoResize v-model="data[field]" />
                                            </template>
                                            <template #filter="{ filterModel, filterCallback }">
                                                <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter"  />
                                            </template>
                                        </Column>

                                        <Column field="registryCalculationType" :header="$t('trueUp.registryCalculationType')" >
                                            <template #editor="{ data }">
                                                <GenericCustomMasterDataAutocompleteV2
                                                class="p-inputtext-sm w-full"
                                                v-model="data.idRegistryCalculationType"
                                                api="masterdata/registry-calculation-type-combo" 
                                                name="masterdata-calculation-type-combo"/> 
                                            </template>    
                                            <template #filter="{ filterModel, filterCallback }">
                                                <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter"  />
                                            </template>                       
                                        </Column>

                                        <Column field="quantityUnitOfMeasureCode" :header="$t('trueUp.quantityUnitOfMeasureCode')" >
                                            <template #editor="{ data, field }">
                                                <GenericCustomMasterDataAutocompleteV2
                                                class="p-inputtext-sm w-full"
                                                v-model="data[field]"
                                                api="masterdata/unit-of-measure-combo?getOnlyValid=true&scope=PriceFormula" 
                                                name="masterdata-unit-of-measure-combo"/> 
                                            </template>
                                            <template #filter="{ filterModel, filterCallback }">
                                                <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter"  />
                                            </template>
                                        </Column>

                                        <Column field="currencyCode" :header="$t('trueUp.currencyCode')" >
                                            <template #editor="{ data, field }">                                             
                                                <GenericCustomMasterDataAutocompleteV2
                                                class="p-inputtext-sm w-full"
                                                v-model="data[field]"
                                                api="masterdata/currency-combo?getOnlyValid=true" 
                                                name="masterdata-currency-combo"/>                                         
                                            </template>
                                            <template #filter="{ filterModel, filterCallback }">
                                                <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter"  />
                                            </template>
                                        </Column>
                                        <Column field="formula" :header="$t('trueUp.formula')" >
                                            <template #editor="{ data, field }">
                                                <InputText class="w-full" autoResize v-model="data[field]" />
                                            </template>
                                        </Column>
                                    </DataTable>
                                </div>
                            </div>
                        </template>
                    </Card>
                </div>              
            </div>
            <Card class="col-12" >
                <template #content>

                    <Dialog v-model:visible="showPriceFormulaDetailsDialog" modal class="p-fluid">
                        <div class="field">
                            <label for="rangeFrom">{{ $t('trueUp.rangeFrom') }}</label>
                            <InputText class="w-full p-inputtext-sm mt-1 " id="rangeFrom" type="text" v-model="priceFormulaDetailsItem.rangeFrom"/>
                        </div>

                        <div class="field">
                            <label for="rangeTo">{{ $t('trueUp.rangeTo') }}</label>
                            <InputText class="w-full p-inputtext-sm mt-1 " id="rangeTo" type="text" v-model="priceFormulaDetailsItem.rangeTo"/>
                        </div>

                        <div class="field">
                            <label for="markerBase">{{ $t('trueUp.markerBase') }}</label>
                            <InputText class="w-full p-inputtext-sm mt-1 " id="markerBase" type="text" v-model="priceFormulaDetailsItem.markerBase"/>
                        </div>
                        
                        <template #footer>
                            <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" class="p-button-text" @click="showPriceFormulaDetailsDialog = false"/>
                            <ResponsiveButton :label="$t('btn.save')" icon="pi pi-check" class="p-button-text" @click="submitPriceFormulaDetails"/>
                        </template>
                    </Dialog>

                    <div class="col-12" style="height: calc(30vh)" >
                        <DataTable showGridlines :value="priceFormulaDetails" scrollable :responsiveLayout="'stack'" scrollHeight="flex" sortMode="single"
                            :sortOrder="1" editMode="row" size="small" v-model:editing-rows="editPriceFormulaDetails" @row-edit-save="onPriceFormulaDetailRowEditSave" 
                            dataKey="id" paginator :rows="10" :rowsPerPageOptions="[10, 20, 50]" class="p-datatable-sm" stripedRows >

                            <template #header>
                                <Toolbar>
                                <template #start>
                                    <div class="custom-card-title">{{$t('trueUp.priceFormulaDetails')}} - {{ this.selectedPriceFormula.shortDescription }}</div>
                                </template>

                                <template #end>
                                    <ResponsiveButton :label="$t('btn.add')" icon="pi pi-plus" class="p-button-outlined p-button-sm" @click="openDialogAddPriceFormulaDetails"  v-if="!uiPermissions('priceFormulaDetailsAddButton').isHidden" />
                                </template>
                            </Toolbar>
                            </template>
                            
                            <Column :rowEditor="true" style="width: 150px;" v-if="!uiPermissions('priceFormulaDetailsEditButton').isHidden" />

                            <Column field="rangeFrom" :header="$t('trueUp.rangeFrom')" >
                                <template #editor="{ data, field }">
                                    <InputText class="w-full" autoResize v-model="data[field]" />
                                </template>
                            </Column>

                            <Column field="rangeTo" :header="$t('trueUp.rangeTo')" >
                                <template #editor="{ data, field }">
                                    <InputText class="w-full" autoResize v-model="data[field]" />
                                </template>
                            </Column>

                            <Column field="markerBase" :header="$t('trueUp.markerBase')" >
                                <template #editor="{ data, field }">
                                    <InputText class="w-full" autoResize v-model="data[field]" />
                                </template>
                            </Column>

                            <Column>
                                <template #body="slotProps">                        
                                    <Button icon="pi pi-trash" v-tooltip="$t('trueUp.deletePriceFormulaDetails')" class="p-button-sm p-button-rounded p-button-outlined mr-1 mb-1" 
                                    size="small" @click="deleteDetails(slotProps.data.id)" v-if="!uiPermissions('priceFormulaDetailsDeleteButton').isHidden" />
                                </template>
                            </Column>
                        </DataTable>
                    </div>
                </template>
            </Card>
        </div>                    
    </main>
</template>

<style>
    .custom-card-title{
        font-size: medium;
    }
</style>